import { render, staticRenderFns } from "./UserProfileBtn.vue?vue&type=template&id=2d40fe69&scoped=true&"
import script from "./UserProfileBtn.vue?vue&type=script&lang=js&"
export * from "./UserProfileBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40fe69",
  null
  
)

export default component.exports